module.exports = __webpack_public_path__ + "static/media/who.be07b3a6.png";